const atsColorPicker = (text) => {
  let color = {
    bg: "",
    text: "#fff",
  };
  switch (text?.toLowerCase()) {
    case "ok":
    case "online":
      color = {
        ...color,
        bg: "#008331",
      };
      break;
    case "warning":
    case "idle":
      color = {
        ...color,
        bg: "#FED60E",
        text: "#000"
      };
      break;
    case "critical":
    case "error":
    case "lost":
      color = {
        ...color,
        bg: "#FF8027",
      };
      break;
    case "offline":
      color = {
        ...color,
        bg: "#B95319",
      };
      break;
    case "in-transit":
      color = {
        ...color,
        bg: "#006FC1",
      };
      break;
    default:
      color = {
        ...color,
        bg: "#6F7171",
      };
      break;
  }
  return color;
};

export default atsColorPicker;
